import { Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { validateEmptyFields } from "../../helpers/util";
import BackButton from "../BackButton";
import InputTextFieldGrid from "../common/InputTextFieldGrid";
import CustomButton from "components/CustomButton";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const LawfulOperatorForm = ({
  defaultValues,
  submit,
  validate,
}) => {
  const navigate = useNavigate();
  const { currentOperator } = useSelector((store) => store.operators);
  const { control, handleSubmit } = useForm({ defaultValues });
  const watch = useWatch({ control });
  const [disabled, setDisabled] = useState(true);
  useEffect(() => {
    setDisabled(validateEmptyFields(watch, { validate }));
    // eslint-disable-next-line
  }, [watch]);

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <div>
          <BackButton click={() => navigate(-1)} />
        </div>
        <div className="container-title">
          <div className="title">Recargas Celular - Operadora</div>
          <div className="subtitle">{currentOperator.name}</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid container m={"20px"} maxWidth={"70%"} justifyContent="center" >
          <Grid
            container
            item
            direction="column"
            justifyContent="center"
            alignItems="center"
            wrap="nowrap"
            xs={4}
            spacing={3}
          >
            <InputTextFieldGrid
              control={control}
              name="name"
              label="Nombre"
              required={"Debes agregar un nombre a la denominación extra"}
              xs={2}
            />
            <InputTextFieldGrid
              control={control}
              name="description"
              multiline={true}
              label="Descripción"
              xs={2}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <CustomButton
            disabled={disabled}
            click={handleSubmit(submit)}
            name={"Guardar"}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default LawfulOperatorForm;
